import request from "@/utils/request";
import { Local } from '@/utils/storage'
import { dateFormat } from "@/utils/date";
//新增区域
export function addArea(data: any) {
    let path = "/shared/venueArea/insert"
    let param = {
        venue_id: Local.get("current_venue").id,
        ...data
    }

    return request.post(path, param)
}

//更新区域
export function updateArea(data: any) {
    let path = "/shared/venueArea/update"
    let param = {
        venue_id: Local.get("current_venue").id,
        ...data
    }

    return request.post(path, param)
}

//新增场地
export function addVenueDevice(data: any) {
    let path = "/shared/venueDevice/insert"
    let param = {
        venue_id: Local.get("current_venue").id,
        ...data
    }

    return request.post(path, param)
}

//更新场地
export function updateVenueDevice(data: any) {
    let path = "/shared/venueDevice/update"
    let param = {
        venue_id: Local.get("current_venue").id,
        ...data
    }

    return request.post(path, param)
}

//新增服务
export function addService(data: any) {
    let path = "/shared/deviceService/insert"
    let param = {
        venue_id: Local.get("current_venue").id,
        ...data
    }

    return request.post(path, param)
}

//更新服务
export function updateService(data: any) {
    let path = "/shared/deviceService/update"
    let param = {
        venue_id: Local.get("current_venue").id,
        ...data
    }

    return request.post(path, param)
}


//新增服务
export function addMap(data: any) {
    let path = "/shared/distributionMap/insert"
    let param = {
        venue_id: Local.get("current_venue").id,
        ...data
    }

    return request.post(path, param)
}

//更新服务
export function updateMap(data: any) {
    let path = "/shared/distributionMap/update"
    let param = {
        venue_id: Local.get("current_venue").id,
        ...data
    }

    return request.post(path, param)
}

/**
 * 初始化机构场馆
 * @param data 
 * @returns 
 */
export function initSpace() {
    let mechanism = Local.get("current_mechanism")
    let path = "/shared/sharedSpace/mechanismInitSpace"
    let param = {
        mechanism_id: mechanism.id,
        support_means: mechanism.support_means,
        qualifications_pic: mechanism.qualifications_pic,
        logo: mechanism.mechanism_logo,
        facade_view: mechanism.facade_view,
        introduction_pic: mechanism.introduction_pic,
        name: mechanism.mechanism_name,
        telephone: mechanism.mechanism_telephone,
        contact_telephone: mechanism.contact_telephone,
        contacts: mechanism.contacts,
        categories: '体育运动',
        categories_child: mechanism.categories_child.replace(/\//g,','),
        address: mechanism.mechanism_addr,
        longitude:mechanism.longitude,
        latitude:mechanism.latitude,
        province: mechanism.province,
        city: mechanism.city,
        district: mechanism.district,
        opentime: '周一至周日09:00-21:00',
        type: 'venue',
        operate: 3
    }

    return request.post(path, param)
}



export function getMecVenue() {
    let path = "/shared/sharedSpace/queryMecVenue"
    let param = {
        mechanism_id: Local.get("current_mechanism").id,
    }

    return request.get(path, param)
}

/**
 * 查询场馆场地
 * @returns 
 */
export function queryVenueDevice(data:any) {
    let path = "/shared/venueDevice/queryListPage"
    let param = {
        ...data,
        venue_id: Local.get("current_venue").id,
    }

    return request.get(path, param)
}

/**
 * 查询场地预约情况
 * @returns 
 */
 export function deviceAppointCount(data:any) {
    if(!Local.get("current_venue")){
       return Promise.reject()
    }
    let path = "/shared/deviceScheduling/queryMecDayInfo"
    let param = {
        venue_id: Local.get("current_venue").id,
        ...data
    }

    return request.get(path, param)
}

/**
 * 查询场地预约情况
 * @returns 
 */
 export function deviceAppointDayCount(data:any) {
    let path = "/shared/deviceScheduling/queryByVenue"
    let param = {
        venue_id: Local.get("current_venue").id,
        ...data
    }

    return request.get(path, param)
}

//获取场地区域
export function getVenueAreas() {

    if(!Local.get("current_venue")){
        return Promise.reject()
    }

    let path = "/shared/venueArea/query"
    let param = {
        venue_id: Local.get("current_venue").id,
    }

    return request.get(path, param)
}


//获取场地服务列表
export function getDevciceServieList(param:Object) {
    let path = "/shared/deviceService/queryListPage"

    return request.get(path, param)
}

//创建预约排期表
export function createSchedulingTemplate(data:any) {
    let path = "/shared/deviceScheduling/createTemplate"
    let param = {
        venue_id: Local.get("current_venue").id,
        ...data
    }

    return request.post(path, param)
}


//设置场地已经预约人数
export function setDeviceAppoedCount(data:any) {
    let path = "/shared/deviceAppointmentRecord/setCount"
   
    return request.post(path, data)
}



//获取场地区域
export function getMallVenueAreas() {
    if(!Local.get("managerInfo").mechanism_id){
        return Promise.reject()
    }

    
    let path = "/shared/venueArea/queryByMecId"
    let param = {
        mechanism_id: Local.get("managerInfo").mechanism_id,
    }

    return request.get(path, param)
}


//更新场馆
export function updateVenue(data:any) {
    data.id= Local.get("current_venue").id
    let path = "/shared/sharedVenue/update"
   
    return request.post(path, data)
}

export function getVenueById() {
    let data = {
        id : Local.get("current_venue").id
    }
    
    let path = "/shared/sharedVenue/findById"
   
    return request.get(path, data)
}


//核销
export function appointmentWithOff(data:any) {
    data.admin_id= Local.get("managerInfo").id
    data.space_id= Local.get("current_venue").space_id
    let path = "/user/userAppointment/checkAttendClass"
   
    return request.post(path, data)
}


//场馆预订下单
export function submitCashierOrder(param:any){
    param.mechanism_id= Local.get("current_mechanism").id
    let path = "/user/coopMechanismRelative/submitCashierVenueOrder"
  
    return request.post(path,param)
}

//锁场
export function lockAppointment(param:any){
    let path = "/shared/deviceAppointmentRecord/lock"
  
    return request.post(path,param)
}

//解锁
export function unlockAppointment(param:any){
    let path = "/shared/deviceAppointmentRecord/unlock"
  
    return request.post(path,param)
}


//固定场次
export function fixedAppoListCheck(param:any){
    let path = "/shared/venueDevice/fixedCheck"
  
    return request.post(path,param)
}


//换场
export function transferDeviceTime(param:any){
    let path = "/shared/userAppointmentDeviceRecord/transferTime"
  
    return request.post(path,param)
}


//订单类型数据
export function circleData(data:any){
    if(!Local.get("current_venue")){
        return Promise.resolve({data:[]})
    }
    let path = "/shared/userAppointmentDeviceRecord/circleData"
    let param:any = {
        venue_id: Local.get("current_venue").id,
        ...data
    }
    return request.post(path,param)
}


//设备使用情况
export function deviceUseInfoList(data:any){
    if(!Local.get("current_venue")){
        return Promise.resolve({data:[]})
    }
    let path = "/shared/venueDevice/deviceUseInfoList"
    let param:any = {
        venue_id: Local.get("current_venue").id,
        ...data
    }
    return request.get(path,param)
}

//开台
export function createOpenTableOrder(data:any){
    if(!Local.get("current_venue")){
        return Promise.resolve({data:[]})
    }
    let path = "/shared/openTableOrder/create"
    let param:any = {
        venue_id: Local.get("current_venue").id,
        handler_id: Local.get("managerInfo").id,
        ...data
    }
    return request.post(path,param)
}


//开台订单详情
export function getOpenTableOrderDetails(id:any){
    let path = "/shared/openTableOrder/detail/"+id
    return request.get(path,{})
}


//修改订单
export function updateOpenTableInfo(data:any){
    let path = "/shared/openTableOrder/update"
    let param:any = {
        ...data
    }
    return request.post(path,param)
}


//开台订单结算
export function openTableOrderSettle(id:any){
    let path = "/shared/openTableOrder/settle/"+id
    return request.get(path,{})
}

//开台订单取消
export function openTableOrderCancel(data:any){
    let path = "/shared/openTableOrder/cancel/"+data.id
    return request.post(path,{})
}



//开台订单延期
export function openTableOrderExtend(data:any){
    let path = "/shared/openTableOrder/extend"
    return request.post(path,data)
}



//开台订单取消延期
export function openTableOrderCancelExtend(data:any){
    let path = "/shared/openTableOrder/cancelExtend/"+data.id
    return request.post(path,{})
}

//开台订单暂停
export function openTableOrderPause(data:any){
    let path = "/shared/openTableOrder/pause"
    let param = {
        orderId: data.id
    }
    return request.get(path, param)
}

//开台订单恢复
export function openTableOrderResume(data:any){
    let path = "/shared/openTableOrder/resume"
    let param = {
        orderId: data.id
    }
    return request.get(path, param)
}

//开台下单
export function submitCashierOpenTable(param:any){
    param.mechanism_id= Local.get("current_mechanism").id
    let path = "/user/coopMechanismRelative/submitCashierOpenTable"
  
    return request.post(path,param)
}

//批量插入开台订单明细
export function batchInsertOrderDetails(data: any) {
    let path = "/shared/openOrderDetails/batchInsert"
    let param = {
        ...data
    }
    return request.post(path, param)
}


export function addOrderDetails(data: any) {
    let path = "/shared/openOrderDetails/addGoods"
    let param = {
        ...data
    }
    return request.post(path, param)
}

//更新开台订单明细
export function updateOpenOrderDetails(data: any) {
    let path = "/shared/openOrderDetails/update"
    let param = {
        ...data
    }
    return request.post(path, param)
}


export function deleteOpenOrderDetails(data: any) {
    let path = "/shared/openOrderDetails/delete"
    let param = {
        ...data
    }
    return request.get(path, param)
}

//查询场馆今日预约订单
export function queryVenueTodayOrders(data: any) {
    let path = "/user/userAppointment/getlist"
    let param = {
        venue_id: Local.get("current_venue").id,
        status: 2,
        master_type: 'shared_device',
        attend_class_start_time: dateFormat(new Date(), 'YYYY-MM-DD 00:00:00'),
        attend_class_end_time: dateFormat(new Date(), 'YYYY-MM-DD 23:59:59'),
        ...data
    }
    return request.get(path, param)
}

//取消预约
export function cancelAppointment(data: any) {
    let path = "/shared/userAppointmentDeviceRecord/cancel"
    let param = {
        ...data
    }
    return request.post(path, param)
}

//查询设施预约记录列表
export function queryDeviceAppointments(data: any) {
    let path = "/shared/userAppointmentDeviceRecord/queryListPage"
    let param = {
        venue_id: Local.get("current_venue").id,
       
        ...data
    }
    return request.get(path, param)
}


//设置门店的推荐
export function setVenueExpertRecomm() {
    let path = "/shared/sharedVenue/setNearExpert"
    let param = {
        id: Local.get("current_venue").id,
    }
    return request.post(path, param)
}